export function isNativeApp() {
  return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform();
}

// Presentation only: installed websites still use browser auth, APIs and permissions.
export function isAppLayout() {
  return isNativeApp() || (typeof window !== 'undefined' && (
    ('standalone' in window.navigator && window.navigator.standalone === true) ||
    window.matchMedia?.('(display-mode: standalone)').matches === true
  ));
}

export function nativeRequestHeaders() {
  if (!isNativeApp()) return {};

  const platform = window.Capacitor?.getPlatform?.() || 'native';
  return { 'X-Seiko-Native-App': platform };
}
